import { render, staticRenderFns } from "./IlpaAppBar.vue?vue&type=template&id=9805d1a6&scoped=true"
import script from "./IlpaAppBar.vue?vue&type=script&lang=js"
export * from "./IlpaAppBar.vue?vue&type=script&lang=js"
import style0 from "./IlpaAppBar.vue?vue&type=style&index=0&id=9805d1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805d1a6",
  null
  
)

export default component.exports